"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoImage = exports.VideoImageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var entity_image_1 = require("./entity-image");
var icon_1 = require("../elements/icon");
var icons_1 = require("../icons");
var video_modal_layout_1 = require("./video-modal-layout");
var use_modal_1 = require("../../hooks/use-modal");
var cls = (0, cn_1.classNames)('video-image');
exports.VideoImageDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    background: #000;\n    width: 280px;\n    height: 158px;\n    cursor: pointer;\n  "], ["\n    position: relative;\n    background: #000;\n    width: 280px;\n    height: 158px;\n    cursor: pointer;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 360px;\n    height: 202px;\n  "], ["\n    width: 360px;\n    height: 202px;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 20;\n    opacity: 1;\n    filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.4));\n    ", ";\n  "], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 20;\n    opacity: 1;\n    filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.4));\n    ", ";\n  "])), theme_1.theme.FILL('light'))
});
var OverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    background: rgba(0,0,0,0.05);\n    width: 100%;\n    top: 0;\n    left: 0;\n    height: 100%;\n    z-index: 15;\n\n    &:hover {\n      opacity: 0.00;\n    }\n\n  "], ["\n    position: absolute;\n    background: rgba(0,0,0,0.05);\n    width: 100%;\n    top: 0;\n    left: 0;\n    height: 100%;\n    z-index: 15;\n\n    &:hover {\n      opacity: 0.00;\n    }\n\n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ModalStyles = (0, theme_1.breakpoints)({});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Overlay: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), OverlayStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Modal: (0, styled_components_1.default)(video_modal_layout_1.VideoModalLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles)
};
var VideoImage = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var modal = (0, use_modal_1.useModal)();
  var cardOnClick = function (event) {
    event.preventDefault();
    modal.show(react_1.default.createElement(My.Modal, {
      entity: entity
    }), {
      hideOnOverlayClick: true,
      title: entity.name,
      label: 'Video',
      opacity: 0.98
    });
  };
  return react_1.default.createElement(My.Container, {
    onClick: cardOnClick,
    className: cls.name(className)
  }, react_1.default.createElement(My.Image, {
    entity: entity
  }), react_1.default.createElement(My.Overlay, {
    className: cls.sub('overlay')
  }), react_1.default.createElement(My.Icon, {
    size: 48
  }, react_1.default.createElement(icons_1.Icons.Play, null)));
};
exports.VideoImage = VideoImage;
exports.VideoImage.cls = cls;
exports.VideoImage.defaultProps = exports.VideoImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;